// components/SkeletonLoader.js
import React from 'react';
import styled from 'styled-components';

const theme = {
  backgroundColor: '#F0F8FF', // 使用浅蓝色作为背景色，偏中性且清新
  primaryColor: '#4CAF50', // 清新的绿色，代表生机与活力
  secondaryColor: '#FFD700', // 明亮的金色（未在当前示例中使用）
  fontColor: '#333333', // 深灰色字体，确保可读性
  skeletonColor: '#E0E0E0', // 骨架屏颜色，淡灰色
};

const SkeletonContainer = styled.div`
  background-color: ${theme.backgroundColor};
  padding: 20px;
  border-radius: 15px;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
`;

const SkeletonTitle = styled.div`
  height: 30px;
  background-color: ${theme.skeletonColor};
  margin-bottom: 15px;
  border-radius: 5px;
`;

const SkeletonDetails = styled.div`
  height: 20px;
  background-color: ${theme.skeletonColor};
  margin-bottom: 10px;
  border-radius: 5px;
`;

function SkeletonLoader() {
  return (
    <SkeletonContainer>
      <SkeletonTitle />
      <SkeletonDetails />
      <SkeletonDetails />
      <SkeletonDetails />
      <SkeletonDetails />
    </SkeletonContainer>
  );
}

export default SkeletonLoader;